// extracted by extract-css-chunks-webpack-plugin
module.exports = {"showLarge":"OrderDetailsSkeleton-22b0194656b83011","listItems":"OrderDetailsSkeleton-1717db12f70fd0f3","listDivider":"OrderDetailsSkeleton-6067385985113a63"};